import React, {useState} from "react";
import {Card, Col, Container, InputGroup, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import * as yup from "yup";
import Button from "react-bootstrap/Button";
import provList from "../../_helpers/provList.js";
import {signUpApi} from "../../api/signup.js";
import {observer} from "mobx-react";
import bctcLogo from "../../images/BCTC_Logo_Horiz_small.png";
function RegisterPage() {
    const [pageState,setPageState] = useState({
        formSubmitted: false
    });
    const schema = yup.object().shape({
        firstName: yup.string().required('First Name is required'),
        lastName: yup.string().required('Last Name is required'),
        organizationName: yup.string()
            .when('organization', {
                is: 'true',
                then: () => yup.string().required("Company Name is required")
            }),
        email: yup.string().required('Email is required').email('Invalid email format'),
        password: yup.string()
            .required("Password is required")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                "Password must be at least 8 characters, with an uppercase letter, lowercase letter, and a number."
            ),
        passwordConfirm: yup.string()
            .required("Password Confirm is required")
            .oneOf([yup.ref('password')], 'Passwords must match'),
        address: yup.string().required('Address is required'),
        city: yup.string().required('City is required'),
        prov: yup.string().required('Province is required'),
        postCode: yup.string().required('Postal Code is required'),
        country: yup.string().required('Country is required'),
        phoneNumber: yup.string().required('Phone number is required'),
        organization: yup.string().required("Please select whether this is a company or personal account"),
        orgType: yup.string()
            .when('organization', {
                is: 'true',
                then: () => yup.string().required("Please choose type of organization")
            }),
        terms: yup.bool().required().oneOf([true], 'Terms must be accepted'),
    });

    if (pageState.formSubmitted){
        return (
            <div className="auth-layout">
                <Container style={{maxWidth: 960}}>
                    <Card className="auth-card p-4 mx-auto">
                    <div className="auth-header">
                        <img src={bctcLogo} height="64" alt="BCTC logo" />
                        <h1 className="auth-title">Registration Submitted</h1>
                        <p className="auth-subtitle">Check your email to confirm and activate your account.</p>
                    </div>
                    </Card>
                </Container>
            </div>
        )
    } else {
        return (
            <Container style={{maxWidth: 960}}>
                <Card className="auth-card p-4 mx-auto">
                    <div className="auth-header">
                        <img src={bctcLogo} height="64" alt="BCTC logo" />
                        <h1 className="auth-title">Create your account</h1>
                        <p className="auth-subtitle">Sign up to start ordering tax certificates.</p>
                    </div>
                    <Card.Body className="p-0">
                    <Formik
                        validationSchema={schema}
                        onSubmit={async (values, { setSubmitting }) => {
                            try {
                                setSubmitting(true);
                                signUpApi.customerSignup(values.firstName, values.lastName, values.email, values.password, values.phoneNumber,
                                    values.organization, values.organizationName, values.orgType, values.address, values.city, values.prov, values.postCode, values.country);
                            } finally {
                                setSubmitting(false);
                                setPageState(prevState => {
                                    return {...prevState, formSubmitted : true}
                                });
                            }

                        }}
                        initialValues={{
                            firstName: '',
                            lastName: '',
                            organizationName: '',
                            username: '',
                            email: '',
                            password: '',
                            confirmPassword: '',
                            address: '',
                            phoneNumber: '',
                            city: '',
                            prov: 'BC',
                            postCode: '',
                            country: 'CA',
                            orgType: "",
                            organization: '',
                            terms: false,
                        }}
                    >
                        {({ handleSubmit, handleChange, touched, values, isSubmitting, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="4" controlId="firstName">
                                        <Form.Label>First name</Form.Label>
                                        <InputGroup hasValidation>
                                            <Form.Control
                                                type="text"
                                                name="firstName"
                                                value={values.firstName}
                                                onChange={handleChange}
                                                isInvalid={touched.firstName && !!errors.firstName}
                                            />
                                            {touched.firstName && (<Form.Control.Feedback type="invalid">
                                                {errors.firstName}
                                            </Form.Control.Feedback>)}
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="lastName">
                                        <Form.Label>Last name</Form.Label>
                                        <InputGroup hasValidation>
                                            <Form.Control
                                                type="text"
                                                name="lastName"
                                                value={values.lastName}
                                                onChange={handleChange}
                                                isInvalid={touched.lastName && !!errors.lastName}
                                            />
                                            {touched.lastName && (<Form.Control.Feedback type="invalid">
                                                {errors.lastName}
                                            </Form.Control.Feedback>)}
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="organization">
                                        <Form.Label>Account type</Form.Label>
                                        <InputGroup hasValidation>
                                            <Form.Check
                                                inline
                                                label="Personal"
                                                name="organization"
                                                type="radio"
                                                id={`personal-radio`}
                                                checked={values.organization === 'false'}
                                                value="false"
                                                isInvalid={touched.organization && !!errors.organization}
                                                onChange={handleChange}
                                            />
                                            <Form.Check
                                                inline
                                                label="Company"
                                                name="organization"
                                                type="radio"
                                                id={`company-radio`}
                                                checked={values.organization === 'true'}
                                                value="true"
                                                isInvalid={touched.organization && !!errors.organization}
                                                onChange={handleChange}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Row>
                                {values.organization === 'true' && (<Row className="mb-3">

                                    <Form.Group as={Col} md="4" controlId="organizationName">
                                        <Form.Label>Company Name</Form.Label>
                                        <InputGroup hasValidation>
                                            <Form.Control
                                                type="text"
                                                name="organizationName"
                                                value={values.organizationName}
                                                onChange={handleChange}
                                                isInvalid={touched.organizationName && !!errors.organizationName}
                                            />
                                            {touched.organizationName && (<Form.Control.Feedback type="invalid">
                                                {errors.organizationName}
                                            </Form.Control.Feedback>)}
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="orgType">
                                        <Form.Label>Company Type</Form.Label>
                                        <Form.Select
                                            aria-label="orgType"
                                            name={"orgType"}
                                            value={values.orgType}
                                            onChange={handleChange}
                                            isInvalid={touched.orgType && !!errors.orgType}
                                        >
                                            <option value={""}>--- Choose ---</option>
                                            <option value={"Lawyer"}>Lawyer</option>
                                            <option value={"Notary"}>Notary</option>
                                            <option value={"Financial"}>Financial</option>
                                            <option value={"Other"}>Other</option>
                                        </Form.Select>

                                        {touched.orgType && (<Form.Control.Feedback type="invalid">
                                            {errors.orgType}
                                        </Form.Control.Feedback>)}
                                    </Form.Group>
                                </Row>)}
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="4" controlId="email">
                                        <Form.Label>Email</Form.Label>
                                        <InputGroup hasValidation>
                                            <Form.Control
                                                type="text"
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                isInvalid={touched.email && !!errors.email}
                                            />
                                            {touched.email && (<Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>)}
                                        </InputGroup>
                                    </Form.Group>
                            <Form.Group as={Col} md="4" controlId="password">
                                <Form.Label>Password</Form.Label>
                                <InputGroup hasValidation>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        isInvalid={touched.password && !!errors.password}
                                    />
                                    {touched.password && (<Form.Control.Feedback type="invalid">
                                        {errors.password}
                                    </Form.Control.Feedback>)}
                                </InputGroup>
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="passwordConfirm">
                                <Form.Label>Confirm Password</Form.Label>
                                <InputGroup hasValidation>
                                    <Form.Control
                                        type="password"
                                        name="passwordConfirm"
                                        value={values.passwordConfirm}
                                        onChange={handleChange}
                                        isInvalid={touched.passwordConfirm && !!errors.passwordConfirm}
                                    />
                                    {touched.passwordConfirm && (<Form.Control.Feedback type="invalid">
                                        {errors.passwordConfirm}
                                    </Form.Control.Feedback>)}
                                </InputGroup>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="8" controlId="address">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address"
                                    value={values.address}
                                    onChange={handleChange}
                                    isInvalid={touched.address && !!errors.address}
                                />

                                {touched.address && (<Form.Control.Feedback type="invalid">
                                    {errors.address}
                                </Form.Control.Feedback>)}
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="phoneNumber">
                                <Form.Label>Phone Number</Form.Label>
                                <InputGroup hasValidation>
                                    <Form.Control
                                        type="text"
                                        name="phoneNumber"
                                        value={values.phoneNumber}
                                        onChange={handleChange}
                                        isInvalid={touched.phoneNumber && !!errors.phoneNumber}
                                    />
                                    {touched.phoneNumber && (<Form.Control.Feedback type="invalid">
                                        {errors.phoneNumber}
                                    </Form.Control.Feedback>)}
                                </InputGroup>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="city">
                                <Form.Label>City</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="city"
                                    value={values.city}
                                    onChange={handleChange}
                                    isInvalid={touched.city && !!errors.city}
                                />

                                {touched.city && (<Form.Control.Feedback type="invalid">
                                    {errors.city}
                                </Form.Control.Feedback>)}
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="prov">
                                <Form.Label>Prov / State</Form.Label>
                                <Form.Select
                                    aria-label="prov"
                                    name={"prov"}
                                    value={values.prov}
                                    onChange={handleChange}
                                    isInvalid={touched.prov && !!errors.prov}
                                >
                                    {provList[values.country].map(p => (
                                        <option key={p.code} value={p.code}>{p.name}</option>
                                    ))}
                                </Form.Select>
                                {touched.prov && (<Form.Control.Feedback type="invalid">
                                    {errors.prov}
                                </Form.Control.Feedback>)}
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="postCode">
                                <Form.Label>Postal Code / Zip</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="postCode"
                                    value={values.postCode}
                                    onChange={handleChange}
                                    isInvalid={touched.postCode && !!errors.postCode}
                                />

                                {touched.postCode && (<Form.Control.Feedback type="invalid">
                                    {errors.postCode}
                                </Form.Control.Feedback>)}
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="country">
                                <Form.Label>Country</Form.Label>
                                <Form.Select
                                    aria-label="country"
                                    name={"country"}
                                    value={values.country}
                                    onChange={handleChange}
                                    isInvalid={touched.country && !!errors.country}
                                >
                                    <option value={"CA"}>Canada</option>
                                    <option value={"US"}>United States</option>
                                </Form.Select>

                                {touched.country && (<Form.Control.Feedback type="invalid">
                                    {errors.country}
                                </Form.Control.Feedback>)}
                            </Form.Group>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Check
                                required
                                name="terms"
                                label={<>Agree to our <a href="/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></>}
                                onChange={handleChange}
                                isInvalid={touched.terms && !!errors.terms}
                                feedback={errors.terms}
                                feedbackType="invalid"
                                id="validationFormik0"
                            />
                        </Form.Group>
                        <Row className="g-2">
                            <Col xs={12} md={6}>
                                <div className="d-grid">
                                    <Button type="submit" disabled={isSubmitting}>Submit Registration</Button>
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className="d-grid">
                                    <Button variant="outline-secondary" onClick={() => window.location.href = '/login'}>
                                        Cancel
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                            </Form>
                        )}
                    </Formik>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

}


export default observer(RegisterPage);
